export const CARD_LOST_BRANCH_ID = "identify_asset_challenge.card_lost";

export const IMPLICIT_STEP_IDS = ["check_customer_age", "check_investigation_or_intervention_was_done_prev_month"];

export const getSurveyFieldName = stepId => `survey.${stepId}`;

export const buildStepsMap = steps => Object.fromEntries(steps.map(step => [step.id, step]));

export const findBranch = (step, answer) => step?.branches?.find(branch => branch.text === answer) ?? null;

export const resolveImplicitBranch = (stepId, context) => {
  const { stepsById, customerAge, hasRecentInvestigationOrIntervention } = context;
  const step = stepsById[stepId];

  if (stepId === "check_customer_age") {
    return findBranch(step, customerAge >= 30 ? "Yes" : "No");
  }

  if (stepId === "check_investigation_or_intervention_was_done_prev_month") {
    return findBranch(step, hasRecentInvestigationOrIntervention ? "Yes" : "No");
  }

  return null;
};

export const computeSurveyPath = (steps, answers, context) => {
  const stepsById = buildStepsMap(steps);
  const path = [];
  let stepId = steps[0]?.id;

  while (stepId) {
    const step = stepsById[stepId];
    if (!step) break;

    const isImplicit = IMPLICIT_STEP_IDS.includes(stepId);
    let branch = null;

    if (isImplicit) {
      branch = resolveImplicitBranch(stepId, { ...context, stepsById });
      path.push({ step, branch, isImplicit: true });

      if (!branch) break;

      if (branch.action?.type === "ShowNextStep") {
        stepId = branch.action.nextStepId;
        continue;
      }

      break;
    }

    const answer = answers[stepId];
    if (!answer) {
      path.push({ step, branch: null, isImplicit: false });
      break;
    }

    branch = findBranch(step, answer);
    path.push({ step, branch, isImplicit: false });

    if (!branch) break;

    if (branch.action?.type === "ShowNextStep") {
      stepId = branch.action.nextStepId;
      continue;
    }

    break;
  }

  return path;
};

export const getVisibleUserSteps = path => path.filter(item => !item.isImplicit);

export const getTerminalBranch = path => {
  const lastItem = path[path.length - 1];
  if (!lastItem?.branch) return null;

  const { type } = lastItem.branch.action || {};
  if (type === "ShowNextStep") return null;

  return lastItem.branch;
};

export const getDownstreamStepIds = (steps, changedStepId) => {
  const stepsById = buildStepsMap(steps);
  const downstream = new Set();
  const queue = [];

  const enqueueNextSteps = stepId => {
    const step = stepsById[stepId];
    step?.branches?.forEach(branch => {
      if (branch.action?.type === "ShowNextStep" && branch.action.nextStepId) {
        queue.push(branch.action.nextStepId);
      }
    });
  };

  enqueueNextSteps(changedStepId);

  while (queue.length) {
    const stepId = queue.shift();
    if (!stepId || downstream.has(stepId)) continue;

    downstream.add(stepId);
    enqueueNextSteps(stepId);
  }

  return Array.from(downstream);
};

